var jquery = require("jquery");
var HabEvents = require("../Global/habitaclia-events");
var StorageService = require("../Global/storage-service").default;

export default class UjInjectCard {

    constructor() {
        this.name = 'hasLed';
        this.respuestaId = '#js-respuesta-similares .sim-full';
        this.templateCardId = '{{js-card-uj-similar}}';
        this.templateId;
        this.storageService;
        this.bindEvent();
    }

    bindEvent() {
        jquery.subscribe(HabEvents.EventsEnum.ConfirmacionSolicitudEnviada, ()=>{this.userHasLead();});
    }

    userHasLead() {
        this.storageService = new StorageService();
        if(!this.storageService.itemExist(this.name)){
            this.storageService.setItem(this.name, true);
            this.createCard();
        }
    }

    getId(templateId) {
        const expression = new RegExp(/[-\w]+/g); 
        this.templateId = templateId.match(expression);
    }

    createCard() {
        const templateCardUjSimilar = document.getElementById(this.templateCardId).cloneNode(true);
        this.getId(templateCardUjSimilar.id);
        templateCardUjSimilar.id = this.templateId;
        const simContainer = document.querySelector(this.respuestaId);
        if(simContainer){
            simContainer.insertBefore(templateCardUjSimilar, simContainer.childNodes[0]);
        }
    }

}

/* jshint unused: false */
const ujInjectCardInstance = new UjInjectCard();